import { useState, useEffect } from "react";
import API from "../Context/api";
import { useAuth } from "../Context/AuthContext";
import ErrorMessage from "../Helpers/ErrorMessage";

function EditLocalPurchaseOrderForm({ id, setIsModalOpen, onLpoUpdated }) {
  const [lpoData, setLpoData] = useState(null);
  const [customer, setCustomer] = useState("");
  const [clientLocation, setClientLocation] = useState("");
  const [items, setItems] = useState([]);
  const [description, setDescription] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [uom, setUom] = useState(""); // New state for Unit of Measure
  const [subTotal, setSubTotal] = useState(0);
  const [vat, setVat] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { user } = useAuth();

  useEffect(() => {
    const fetchLpo = async () => {
      setIsLoading(true);
      try {
        const response = await API.get(`/localpurchaseorders/${id}`);
        const lpo = response.data;
        console.log(lpo);
        setLpoData(lpo);
        setCustomer(lpo.lpoDetails.client);
        setClientLocation(lpo.lpoDetails.clientLocation);
        setItems(lpo.lpoDetails.items);

        setSubTotal(lpo.lpoDetails.subTotal);
        setVat(lpo.lpoDetails.vat);
        setGrandTotal(lpo.lpoDetails.grandTotal);
      } catch (error) {
        console.error("Error fetching LPO:", error);
        setErrorMessage("Failed to load LPO data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLpo();
  }, [id]);

  useEffect(() => {
    const calculatedSubTotal = items.reduce(
      (sum, item) => sum + (item.totalPrice || item.quantity * item.unitPrice),
      0
    );
    setSubTotal(calculatedSubTotal);
    const calculatedVat = Math.round(calculatedSubTotal * 0.18);
    setVat(calculatedVat);
    setGrandTotal(calculatedSubTotal + calculatedVat);
  }, [items]);

  const addItem = () => {
    if (description.trim() !== "" && quantity > 0 && unitPrice > 0) {
      const totalPrice = parseFloat(quantity) * parseFloat(unitPrice);
      setItems([
        ...items,
        { description, uom, quantity, unitPrice, totalPrice },
      ]);
      setDescription("");
      setQuantity("");
      setUnitPrice("");
      setUom("");
    }
  };

  const deleteItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  // const updateLpo = async () => {
  //   if (!customer.trim() || !clientLocation.trim() || items.length === 0) {
  //     alert("Please add a customer name, location, and at least one item.");
  //     return;
  //   }

  //   const updatedData = { ...lpoData };
  //   updatedData.lpoDetails.client = customer;
  //   updatedData.lpoDetails.clientLocation = clientLocation;
  //   updatedData.lpoDetails.items = items;
  //   updatedData.lpoDetails.subTotal = subTotal;
  //   updatedData.lpoDetails.vat = vat;
  //   updatedData.lpoDetails.grandTotal = grandTotal;

  //   try {
  //     await API.put(`/localpurchaseorders/${id}`, updatedData);
  //     onLpoUpdated();
  //     setIsModalOpen(false);
  //   } catch (error) {
  //     console.error("Error updating LPO:", error);
  //     alert(`Failed to update LPO: ${error.message || "Unknown error"}`);
  //   }
  // };

  const updateLpo = async () => {
    if (!customer.trim() || !clientLocation.trim() || items.length === 0) {
      alert("Please add a customer name, location, and at least one item.");
      return;
    }

    const updatedData = {
      customer,
      clientLocation,
      items,
      lpoHeader: lpoData.lpoHeader, // Keep lpoHeader data
    };

    try {
      setIsSubmitting(true);
      await API.put(`/localpurchaseorders/${id}`, updatedData);
      onLpoUpdated();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error updating LPO:", error);
      // alert(`Failed to update LPO: ${error.message || "Unknown error"}`);
      const errorMsg =
        error.response?.data?.message || "Failed to update computer";
      setErrorMessage(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
    //   <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
    //     <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto">
    //       <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
    //         Local Purchase Order
    //       </h2>

    //       {/* Customer and Client Location */}
    //       <div className="grid grid-cols-1 gap-4 mb-6">
    //         <div>
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             Customer Name
    //           </label>
    //           <input
    //             type="text"
    //             className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
    //             placeholder="Enter customer name"
    //             value={customer}
    //             onChange={(e) => setCustomer(e.target.value)}
    //           />
    //         </div>
    //         <div>
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             Client Location
    //           </label>
    //           <textarea
    //             className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
    //             placeholder="e.g., P.O. Box 345,
    //         Mulwana Road,
    //         Kampala Uganda"
    //             rows="5"
    //             value={clientLocation}
    //             onChange={(e) => setClientLocation(e.target.value)}
    //           />
    //         </div>
    //       </div>

    //       {/* Item Entry */}
    //       <div className="mb-6">
    //         <h2 className="text-lg font-semibold text-gray-800 mb-2">
    //           Add Items
    //         </h2>
    //         <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
    //           <textarea
    //             className="md:col-span-2 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
    //             placeholder="Item description"
    //             rows="2"
    //             value={description}
    //             onChange={(e) => setDescription(e.target.value)}
    //           />
    //           <input
    //             type="text"
    //             className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
    //             placeholder="U.O.M (e.g., pcs)"
    //             value={uom}
    //             onChange={(e) => setUom(e.target.value)}
    //           />
    //           <input
    //             type="number"
    //             className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
    //             placeholder="Qty"
    //             value={quantity}
    //             onChange={(e) => setQuantity(e.target.value)}
    //           />
    //           <input
    //             type="number"
    //             className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
    //             placeholder="Unit Price (USD)"
    //             value={unitPrice}
    //             onChange={(e) => setUnitPrice(e.target.value)}
    //           />
    //           <button
    //             onClick={addItem}
    //             className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
    //           >
    //             Add Item
    //           </button>
    //         </div>
    //       </div>

    //       <div className="flex-1 overflow-y-auto mb-4">
    //         <table className="w-full border-collapse border border-gray-300">
    //           <thead>
    //             <tr className="bg-gray-100 text-gray-700">
    //               <th className="border p-3 text-left">Description</th>
    //               <th className="border p-3 text-center">U.O.M</th>
    //               <th className="border p-3 text-center">Qty</th>
    //               <th className="border p-3 text-center">Unit Price (USD)</th>
    //               <th className="border p-3 text-center">Total Price (USD)</th>
    //               <th className="border p-3 text-center">Actions</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             {items.map((item, index) => (
    //               <tr key={index} className="text-center">
    //                 <td className="border p-2">{item.description}</td>
    //                 <td className="border p-2">{item.quantity}</td>
    //                 <td className="border p-2">{item.uom}</td>
    //                 <td className="border p-2">{item.unitPrice}</td>
    //                 <td className="border p-2">{item.totalPrice}</td>
    //                 <td className="border p-2">
    //                   <button
    //                     onClick={() => deleteItem(index)}
    //                     className="bg-red-500 text-white px-2 py-1 rounded"
    //                   >
    //                     Delete
    //                   </button>
    //                 </td>
    //               </tr>
    //             ))}
    //           </tbody>
    //         </table>
    //       </div>

    //       <div className="mt-4 text-right text-lg font-semibold">
    //         Sub Total: USD {subTotal.toLocaleString()}
    //         <br />
    //         VAT 18%: USD {vat.toLocaleString()}
    //         <br />
    //         Grand Total: USD {grandTotal.toLocaleString()}
    //       </div>

    //       <div className="mt-4 flex justify-end space-x-2">
    //         <button
    //           onClick={updateLpo}
    //           className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
    //         >
    //           Update LPO
    //         </button>
    //         <button
    //           onClick={() => setIsModalOpen(false)}
    //           className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
    //         >
    //           Cancel
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
      <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col h-[90vh] sm:h-[80vh]">
        {/* Header (Fixed) */}
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">
            Local Purchase Order
          </h2>
          <ErrorMessage message={errorMessage} />
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto px-4 py-2 space-y-4">
          {/* Customer Name & Client Location */}
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Customer Name
              </label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter customer name"
                value={customer}
                onChange={(e) => setCustomer(e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Client Location
              </label>
              <textarea
                rows="5"
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
                placeholder="e.g., P.O. Box 345, Mulwana Road, Kampala Uganda"
                value={clientLocation}
                onChange={(e) => setClientLocation(e.target.value)}
              />
            </div>
          </div>

          {/* Add Item Inputs */}
          <div className="grid grid-cols-12 gap-2 items-start">
            {/* Description */}
            <textarea
              rows="2"
              className="col-span-4 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
              placeholder="Item description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            {/* UOM */}
            <input
              type="text"
              className="col-span-2 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="U.O.M"
              value={uom}
              onChange={(e) => setUom(e.target.value)}
            />

            {/* Qty */}
            <input
              type="number"
              className="col-span-2 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Qty"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />

            {/* Unit Price */}
            <input
              type="number"
              className="col-span-2 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Unit Price (USD)"
              value={unitPrice}
              onChange={(e) => setUnitPrice(e.target.value)}
            />

            {/* Button */}
            <button
              onClick={addItem}
              className="col-span-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition w-full"
            >
              Add Item
            </button>
          </div>

          {/* Items Table */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-200 text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border p-2 text-left">Description</th>
                  <th className="border p-2 text-center">U.O.M</th>
                  <th className="border p-2 text-center">Qty</th>
                  <th className="border p-2 text-center">Unit Price (USD)</th>
                  <th className="border p-2 text-center">Total Price (USD)</th>
                  <th className="border p-2 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50 text-center">
                    <td className="border p-2 text-left">{item.description}</td>
                    <td className="border p-2">{item.uom}</td>
                    <td className="border p-2">{item.quantity}</td>
                    <td className="border p-2">{item.unitPrice}</td>
                    <td className="border p-2">{item.totalPrice}</td>
                    <td className="border p-2">
                      <button
                        onClick={() => deleteItem(index)}
                        className="bg-red-500 text-white px-2 py-1 rounded text-xs hover:bg-red-600"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Totals */}
          <div className="text-right text-base font-semibold text-gray-800">
            <p>Sub Total: USD {subTotal.toLocaleString()}</p>
            <p>VAT (18%): USD {vat.toLocaleString()}</p>
            <p>Grand Total: USD {grandTotal.toLocaleString()}</p>
          </div>
        </div>

        {/* Footer Buttons (Fixed) */}
        <div className="p-4 border-t border-gray-200 flex flex-col sm:flex-row justify-end gap-2">
          <button
            onClick={() => setIsModalOpen(false)}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={updateLpo}
            disabled={isSubmitting}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
              isSubmitting
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditLocalPurchaseOrderForm;
